import { render } from "./Rooms.vue?vue&type=template&id=058555c0&scoped=true&bindings={}"
import script from "./Rooms.vue?vue&type=script&lang=ts"
export * from "./Rooms.vue?vue&type=script&lang=ts"

import "./Rooms.vue?vue&type=style&index=0&id=058555c0&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-058555c0"

export default script